import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { AxiosConfiguration } from "../../Utils/AxiosConfig";
import { get_Date, getSurveyStatusName } from "../../Utils/commonFunctions";
import dataTableGrid from "../DataTableGrid";

let AdminListSurvey = () => {
  const [listSurvey, setListSurvey] = useState([]);
  const axiosInstance = AxiosConfiguration();
  useEffect(() => {
    managesurveyList();
  }, []);
  const managesurveyList = async () => {
    try {
      const results = await axiosInstance.post("v1/survey_list/");
      setListSurvey(results.data.data);
      console.log(listSurvey)
      if (results.data.data.length > 0) {
        dataTableGrid({
          data_table_id: "#Survey_List",
          paginate: false,
          copy_option: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          csv_option: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          print_option: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          sort_option: [],
        });
      }
    } catch (error) {
      setListSurvey([]);
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title pull-right ">
                          <Link
                            to="/add-survey"
                            className="btn btn-sm custom-btn-primary"
                          >
                            <i className="fa fa-plus"></i> Add Survey
                          </Link>
                        </h3>
                      </div>
                      <div className="card-body">
                        <table
                          id="Survey_List"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Survey Name</th>
                              <th>Company Name</th>
                              <th>Site Name</th>
                              <th>Device Name</th>
                              <th>Created On.</th>
                              <th>Launch Date</th>
                              <th>Completion Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listSurvey &&
                              listSurvey.map((row, index) => (
                                <tr key={row.survey_id}>
                                  <td>{++index}</td>
                                  <td>
                                    <Link
                                      to={
                                        "/AdminSurveyDetails/" + row.survey_id
                                      }
                                      className="custom-link-primary"
                                    >
                                      {row.survey_name}
                                    </Link>
                                  </td>
                                  <td>{row.manufacturer__company_name}</td>
                                  <td>{row.site__site_name}</td>
                                  <td>{row.device__device_name}</td>
                                  <td>{get_Date(row.created_date)}</td>
                                  <td>{get_Date(row.launch_date)}</td>
                                  <td>{get_Date(row.completion_date)}</td>
                                  <td>{getSurveyStatusName(row.status)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListSurvey;
